import "./instrument";

import * as Sentry from "@sentry/react";
import { createRoot } from "react-dom/client";
import { SentryFallback } from "@/components/SentryFallback";
import App from "./App.tsx";
import "./index.css";
import { applyDynamicFavicon, applyEnvBar } from "@/lib/dynamicFavicon";

applyDynamicFavicon();
applyEnvBar();

createRoot(document.getElementById("root")!).render(
  <Sentry.ErrorBoundary fallback={<SentryFallback />} showDialog={false}>
    <App />
  </Sentry.ErrorBoundary>,
);
